import { Box, styled } from '@mui/material';

export const FlexBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between'
});
